import React, { useContext, useEffect, useState } from 'react'
import { apiEndPoint } from '../../../environment'
import { LoginContext } from '../../context/LoginContext'
import axios from 'axios'
import { ToastContainer, toast } from 'react-toastify';


export default function AddSite(props) {

    const { user } = useContext(LoginContext)

    const [siteName, setSiteName] = useState("")
    const [siteUrl, setSiteUrl] = useState("")
    const [uploadImage, setUploadImage] = useState("")
    const [fileInfo, setFileInfo] = useState("")

    function addSubscribeBell() {
        let data = JSON.stringify({
            "siteUrl": siteUrl
        });

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${apiEndPoint}subscribe/bell`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios.request(config)
            .then((response) => {
                console.log(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }


    function addWelcomeNotification() {
        let data = JSON.stringify({
            "siteUrl": siteUrl
        });

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${apiEndPoint}welcome/notification`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios.request(config)
            .then((response) => {
                addSubscribeBell()
            })
            .catch((error) => {
                console.log(error);
            });
    }

    function addWebsiteInfo() {
        let data = JSON.stringify({
            "websiteUrl": siteUrl
        });

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${apiEndPoint}websiteinfo`,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios.request(config)
            .then((response) => {
                addWelcomeNotification()
            })
            .catch((error) => {
                console.log(error);
            });
    }

    function siteDeatils(siteName, siteUrl) {
        const data = new FormData()
        data.append('siteName', siteName)
        data.append('siteUrl', siteUrl)
        data.append('userId', user.id)
        data.append('icon', fileInfo)

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${apiEndPoint}sitedetails`,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            data: data
        };

        axios.request(config)
            .then((response) => {
                console.log(response.data);
                sessionStorage.setItem("siteUrl", siteUrl);
                props.setActiveStep(1)
                addWebsiteInfo()
            })
            .catch((error) => {
                toast.error(`Error: ${error.response.data.message}`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                });
            });
    }

    const getImage = (e) => {
        setUploadImage(URL.createObjectURL(e.target.files[0]));
        setFileInfo(e.target.files[0]);
    }

    return (
        <>
            <div className="add-site-box-container">
                <div id=" row add-site-step">
                    <div className="col-sm-10 offset-sm-1 add-site-box" data-integration-type="https">
                        <div className="row" style={{ alignItems: 'center' }}>
                            <div className="col-sm-4 change-icon-container">

                                <div className="Neon Neon-theme-dragdropbox">
                                    <input onChange={getImage} style={{ zIndex: 999, opacity: 0, width: '320px', height: '200px', position: 'absolute', right: '0px', left: '0px', marginRight: 'auto', marginLeft: 'auto' }} name="icon" id="icon" type="file" />
                                    <div className="Neon-input-dragDrop"><div className="Neon-input-inner"><div className="Neon-input-icon"><i className="fa fa-file-image-o" /></div><div className="Neon-input-text"><h3>Drag&amp;Drop files here</h3>
                                        <span style={{ display: 'inline-block', margin: '15px 0' }}>or</span></div><a className="Neon-input-choose-btn blue">Browse Files</a></div></div>
                                </div>
                                {
                                    uploadImage ? <img src={uploadImage} className='img mb-4' alt='img' width="340px" height="250px" /> : ""
                                }

                            </div>
                            <div className="col-sm-8 site-details">
                                <div className="form-group">
                                    <label>Select Integration Type: </label>
                                    <div className="site-type">
                                        <div className="typical active" data-integration="Typical Site"><div className="site-type-logo"><img src="https://webpushrapp-3744.kxcdn.com/assets/images/code.png" /></div><div>Typical Site</div></div>
                                    </div>
                                </div>
                                <div className="form-group self-hosted">
                                    <label>Use <a href="#">Typical Site</a> if your <span /> site is self-hosted.</label>
                                </div>
                                <div className="form-group">
                                    <label>Site Name:</label>
                                    <input id="website-name" name="sitename" onChange={(e) => setSiteName(e.target.value)} defaultValue={siteName} type="text" className="form-control" placeholder="Enter a name to remember your website by ..." />
                                </div>
                                <div className="form-group">
                                    <label>URL: <em>(Enter full site url. Example: https://www.sitename.com)</em>
                                        <a id="url-locked" className="atooltip" data-atooltip="Website urls can't be edited after creation. Either make a new site, or contact support for help."><i className="fa fa-info-circle" aria-hidden="true" /></a>
                                        <input type="hidden" name="public_key" className="js-public-key" />
                                        <input type="hidden" name="private_key" className="js-private-key" />
                                    </label>
                                    <input id="website-url" name="siteurl" type="text" onChange={(e) => setSiteUrl(e.target.value)} defaultValue={siteUrl} className="form-control" placeholder="Enter your website url here..." />
                                </div>
                                {/* <div className="form-group form-switch">
                                    <div className="custom-control custom-switch">
                                        <input className="custom-control-input toggleHttpsButton" name="conversion" defaultValue={1} id="customSwitch1" type="checkbox" />
                                        <label className="custom-control-label" htmlFor="customSwitch1">My site is not fully HTTPS</label>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <button className="btn btn-primary next-step" onClick={() => siteDeatils(siteName, siteUrl)} >Next  <img src="https://webpushrapp-3744.kxcdn.com/assets/images/next.png" /> </button>
                    </div>
                </div>
            </div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            />
        </>
    )
}
